import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Producto } from '../../../models/producto';
import { SweetMessage } from '../../../config/sweet-message';
import { ProductoService } from '../../../services/producto.service';
import { Venta } from '../../../models/venta';
import { IfObservable } from 'rxjs/observable/IfObservable';

@Component({
  selector: 'app-lector-barra-modal',
  templateUrl: './lector-barra-modal.component.html',
  styleUrls: ['./lector-barra-modal.component.css'],
  providers: [
    ProductoService,
]
})
export class LectorBarraModalComponent implements OnInit, AfterViewInit {
  public codigo_producto: String;
  public product_barcode: Producto;
  public notfound_barcode: any;
  //public venta: Venta;
  public loading: boolean;
  public msgSweet: SweetMessage;
  public productos: Array<Producto>;
  @Input() bodega_id: String;
  @Output() sendProducto = new EventEmitter();
  @ViewChild('inputBarcode') searchElement: ElementRef;
  constructor(
    public productoService: ProductoService,
		public bsModalRef: BsModalRef,
  ) { 
    this.codigo_producto = "";
    this.productos = [];
    this.product_barcode = null;
    this.loading = false;
    this.msgSweet = new SweetMessage();
    this.notfound_barcode = null;
    this.bodega_id = "";
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.setFocus();
  }

  setFocus(){
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 500);
  }

  onSearchBarcode(event){
    let keycode = event.charCode;

    if( event.keyCode == 13 ){
        
         this.getProductByCodigo();
        //   res => {
        //     //this.sendProducto.emit(this.product_barcode);
            
        //   },
        //   err =>{

        //   }
        // );
    }
  }

  getProductByCodigo(){
    return new Promise((resolve, reject) => {
        let qs  = "?codigo=" + this.codigo_producto;

        this.product_barcode = null;
        this.notfound_barcode = null;

        this.productoService.getWithPrice(this.bodega_id,qs).subscribe(
            res => {
                this.product_barcode = res.data[0];
                if(this.product_barcode){
                  
                  //this.onSubmit(); 
                  this.sendProducto.emit(this.product_barcode);
                }else{
                  
                  this.product_barcode = null;
                  this.notfound_barcode = this.codigo_producto;
              
                }
                this.codigo_producto = "";
                    //this.addProduct(producto);
                    
                    //this.sendObjectProducto(producto);
                resolve();
            },
            err => {
                //this.productos = [];
                this.product_barcode = null;
                reject(err);
            }
        );
    });
  }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/lector-barra-modal/lector-barra-modal.component.ts